<template>
  <a-modal
    :width="1240"
    v-model="seeVisible"
    cancelText="false"
    @ok="visible = false"
    dialogClass="information-up-wrapper_modal"
    centered
    :footer="false"
  >
    <a-tabs v-model="contentType" @change="handleChange">
      <a-tab-pane
        v-for="item in tabOptions"
        :key="item.value"
        :tab="item.label"
      ></a-tab-pane>
    </a-tabs>
    <div class="container-wrapper" v-if="currentContent.length">
      <div v-if="contentType !== 7" class="left-wrapper">
        <div style="margin-bottom: 20px">
          <img style="width: 100px; height: 23px" :src="noticeLog" />
        </div>
        <div class="announcement-title">
          {{ currentContent[announcementIndex].announcementTitle }}
        </div>
        <div
          v-if="currentContent[announcementIndex].announcementOnTime"
          style="color: #a9adb4; font-size: 12px"
        >
          {{
            moment(
              currentContent[announcementIndex].announcementOnTime
            ).format("YYYY-MM-DD hh:mm:ss")
          }}
        </div>
        <a-menu
          :defaultSelectedKeys="[currentMenu]"
          class="menu-wrapper"
          mode="vertical"
        >
          <a-menu-item
            v-for="(item, index) in contentTitles"
            @click="handleChangeMenu(item, index)"
            :key="`${item}_${index}`"
          >
            <span
              ><span class="pointer-container"></span
              ><span class="menu-title-name" v-html="item" />
            </span>
          </a-menu-item>
        </a-menu>
        <div>
          <!-- 了解更多 -->
          <a
            style="
              position: absolute;
              bottom: 0;
              height: 32px;
              color: #1e5af9;
              font-size: 12px;
            "
            @click="informationClick"
          >
            {{ $t("common_btn_know_more") }}
          </a>
          <a
            v-if="announcementIndex < currentContent.length - 1"
            style="
              position: absolute;
              bottom: 0;
              height: 32px;
              color: #1e5af9;
              font-size: 12px;
              right: 40px;
            "
            :loading="isLoading"
            @click="nextClick"
          >
            {{
              $t("common_btn_next_tiao", [$t("common_home_announcement", [])])
            }}
          </a>
        </div>
      </div>
      <div class="content-wrapper">
        <div
          id="information-box-conter"
          class="information mce-content-body"
          :style="{ 'padding-right': contentType !== 7 ? '190px' : '0px' }"
          ref="information"
          v-if="currentContent.length"
        >
          <!-- 内容 -->
          <div class="information-box-conter">
            <div class="information-box-conter_loading" v-if="isLoading">
              <a-spin></a-spin>
            </div>
            <div v-if="!isLoading">
              <div v-if="contentType !== 7" class="information-box-conter_title">
                {{ currentContent[announcementIndex].announcementTitle }}
              </div>
              <div style="position: relative;margin-bottom:45px" v-if="contentType === 7">
                <div
                  v-if="
                    currentContent[announcementIndex].announcementContent
                      .visitLink
                  "
                  style="display: flex; justify-content: center"
                >
                  <a-tooltip
                    placement="top"
                    title="「点击跳转到新页面，查看更多功能信息」"
                  >
                    <a
                      :href="
                        currentContent[announcementIndex].announcementContent
                          .visitLink
                      "
                      target="_blank"
                    >
                      <img
                        width="1200px"
                        :src="
                          currentContent[announcementIndex]
                            .announcementContent.fileList &&
                          currentContent[announcementIndex]
                            .announcementContent.fileList[0].response
                        "
                      />
                    </a>
                  </a-tooltip>
                </div>
                <div style="display: flex; justify-content: center" v-else>
                  <img
                    width="1200px"
                    :src="
                      currentContent[announcementIndex].announcementContent
                        .fileList &&
                      currentContent[announcementIndex].announcementContent
                        .fileList[0].response
                    "
                  />
                </div>
              </div>
              <div v-else>
                <div
                  v-if="currentContent[announcementIndex].announcementContent"
                  style="padding: 0"
                  v-loaded="
                    currentContent[announcementIndex].announcementContent
                  "
                  v-viewer.static="{ movable: false }"
                ></div>
              </div>
            </div>
          </div>
          <!-- 附件 -->
          <div
            class="information-box-conter"
            style="margin-top: 27px"
            v-if="
              currentContent[announcementIndex].enclosureList &&
              currentContent[announcementIndex].enclosureList.length
            "
          >
            <div class="information-box-conter_title">
              {{ $t("common_btn_download_attachment") }}
            </div>
            <div
              class="detail-header-span iconfont-left"
              v-for="(item, index) in currentContent[announcementIndex]
                .enclosureList"
              :key="index"
            >
              <i class="gb-iconfont gb-icon-wendang"></i>
              <span
                @click="
                  enclosureClick(
                    item.enclosureFileUrl,
                    item.enclosureFileName
                  )
                "
                >{{ item.enclosureFileName }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="contentType !== 7" class="right-anchor-wrapper">
      <span
        v-if="
          contentSecondLevelTitles[currentMenu] &&
          contentSecondLevelTitles[currentMenu].length
        "
        :style="{ top: `${currentBallindex * 30}px` }"
        class="anchor-ball"
      ></span>
      <a-anchor
        :affix="false"
        :showInkInFixed="true"
        v-if="contentSecondLevelTitles[currentMenu]"
        :getContainer="() => $refs.information"
        :getCurrentAnchor="() => '#heading_second_0'"
        class="anchor-information-container"
      >
        <a-anchor-link
          class="anchor-information-wrapper"
          v-for="(item, index) in contentSecondLevelTitles[currentMenu] || []"
          @click.native="
            handleAnchorClick($event, index, `heading_second_${item.index}`)
          "
          :key="index"
        >
          <template slot="title">
            <span v-html="item.content"></span>
          </template>
        </a-anchor-link>
      </a-anchor>
    </div>
    <div
      style="position: absolute; bottom: 10px; z-index: 99999; width: 100%"
    >
      <!-- 了解更多 -->
      <a-button
        type="primary"
        style="height: 32px; margin-left: 10px"
        @click="informationClick"
      >
        {{ $t("common_btn_know_more") }}
      </a-button>
      <!-- 下一条 -->
      <a-button
        style="position: absolute; height: 32px; right: 15px"
        :loading="isLoading"
        @click="nextClick"
        v-if="announcementIndex < currentContent.length - 1"
      >
        {{ $t("common_btn_next_tiao", [$t("common_home_announcement", [])]) }}
      </a-button>
      <!-- 我知道了 -->
      <a-button
        style="position: absolute; height: 32px; right: 15px"
        @click="closeClick"
        v-else
      >
        {{ $t("common_btn_i_know") }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import {
  GetAnnouncementYhEjectDetail,
  getLastAnnouncement,
  DownloadImg,
} from "@/api/index";
import { downloadFn } from "@/utils/util.js";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import noticeLog from "@/assets/notice-logo.svg";
import NoticeTips from "./NoticeTips";
import richText from "@/mixins/richText-mixin";
import moment from "moment";
export default {
  mixins: [richText],
  data() {
    const newsType = {
      1: this.$t("common_home_announcement_type1"),
      2: this.$t("common_home_announcement_type2"),
      // 3: this.$t('common_home_announcement_type3'),
      4: this.$t("common_home_announcement_type4"),
      5: this.$t("common_home_announcement_type5"),
    };
    return {
      contentType: 1,
      currentSecondindex: 0,
      noticeLog,
      currentMenu: "",
      currentBallindex: 0,
      contentTitles: [],
      contentSecondLevelTitles: {},
      // shwoInformation: true,
      announcementList: [],
      announcementIndex: 0,
      newsType,
      seeVisible: false,
      scroller: null,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters(["systemCode"]),
    currentContent() {
      if (this.contentType === 7) {
        return this.announcementList.filter(
          (item) => item.announcementType === 7
        );
      } else {
        return this.announcementList.filter(
          (item) => item.announcementType !== 7
        );
      }
    },
    tabOptions() {
      const finder = this.announcementList.find(
        (item) => item.announcementType === 7
      );
      if (finder) {
        return [
          {
            label: "重点功能",
            value: 7,
          },
          {
            label: "版本更新",
            value: 1,
          },
        ];
      }
      return [
        {
          label: "版本更新",
          value: 1,
        },
      ];
    },
  },
  components: {
    tips: NoticeTips,
  },
  methods: {
    moment,
    handleChange(value) {
      this.announcementIndex = 0;
      this.getLastAnnouncement(value);
    },
    handleAnchorClick(event, number, key) {
      event.preventDefault();
      this.currentBallindex = Number(number);
      this.jumpTo(key);
    },
    updateSeeVisible(data = []) {
      this.announcementList = data.map((item) => this.updateDataStr(item));
      this.seeVisible = true;
      this.isLoading = false;
    },
    informationClick() {
      const {
        params: { serviceId, systemCode },
      } = this.$route;
      this.$store.dispatch("entry/SetActiveAsync", {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/notice/announcement`,
      });
      this.seeVisible = false;
      this.isLoading = false;
    },
    getLastAnnouncement(type) {
      getLastAnnouncement({
        ejectFlag: 2,
        ejectPlatformType: 2,
        ejectSystemCode: this.systemCode,
      }).then(({ data }) => {
        // data = Array.from({ length: 10 }).map((item, index) => ({
        //   announcementId: 93,
        //   announcementTitle: "测试",
        //   announcementOnTime: "2021-11-05T16:42:47.000+0800",
        //   announcementType: 7,
        //   announcementContent:
        //     '{"fileList":[{"uid":"vc-upload-1730194192392-3","lastModified":1728959444922,"lastModifiedDate":"2024-10-15T02:30:44.922Z","name":"example.png","size":139701,"type":"image/png","percent":100,"originFileObj":{"uid":"vc-upload-1730194192392-3"},"status":"done","thumbUrl":"data:image/png;base64,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","response":"http://file.eccang.com/ec-saas-file/manager/saas_1730194224398890132086a3f5a52.png?Expires=4883794224&OSSAccessKeyId=LTAI4FwuSvzhB2y5nmjx4NCY&Signature=XNldAs8H75wMe2%2F8efsZYpjvARc%3D"}],"visitLink":"http://baidu.com"}',
        //   enclosureList: null,
        // }));
        this.announcementList = data.map((item) =>
          this.updateDataStr(item, type)
        );
        this.isLoading = false;
        this.seeVisible = true;
      });
    },
    _GetAnnouncementYhDetail() {
      let params = {
        ejectFlag: 2,
        ejectPlatformType: 2,
        ejectSystemCode: this.systemCode,
      };
      GetAnnouncementYhEjectDetail(params).then((res) => {
        const { data = [] } = res;
        this.announcementList = data.map((item) => this.updateDataStr(item));

        if (this.announcementList.length) {
          this.isLoading = false;
          this.seeVisible = true;
        } else {
          console.log("info: version have not update!");
        }
      });
    },
    updateDataStr(item, type) {
      if (item.announcementType === 7) {
        item.announcementContent = JSON.parse(item.announcementContent);
        if (!type) {
          // 7类型是重点功能，比较特殊
          this.contentType = 7;
        }
        return item;
      }
      let contentLinkStr = item.announcementContent;
      this.getAnchorContent(contentLinkStr);
      contentLinkStr = this.replaceAnchorContent(contentLinkStr);
      item.announcementContent =
        this.replaceSecondLevelAnchorContent(contentLinkStr);
      return item;
    },
    getAnchorContent(htmlString) {
      const regex = /<h1[^>]*>(.*?)<\/h1>/g;
      const matches = htmlString.match(regex);
      if (matches) {
        this.contentTitles = matches
          .map((match) => {
            return match.replace(/<\/?h1[^>]*>/g, "");
          })
          .map((html, index) => {
            const value = html.replace(/<[^>]+>/g, "").replace(/&[^;]+;/g, "");
            if (index <= matches.length - 1) {
              let h2Str = htmlString.split(html)[1];
              if (index === matches.length - 1) {
                this.getSecondLevelAnchorContent(value, h2Str);
              } else {
                h2Str = h2Str.split(matches[index + 1])[0];
                this.getSecondLevelAnchorContent(value, h2Str);
              }
            }
            return value;
          });
        this.currentMenu = this.contentTitles[0];
      }
    },
    replaceAnchorContent(htmlString) {
      const regex = /<h1[^>]*>(.*?)<\/h1>/g;
      let idCounter = 0;
      htmlString = htmlString.replace(regex, (match) => {
        var id = "heading_" + idCounter;
        idCounter++;
        return match.replace(
          "<h1",
          '<h1 class="highlight-wrapper" id="' + id + '"'
        );
      });
      return htmlString;
    },
    getSecondLevelAnchorContent(value, htmlString) {
      const regex = /<h2[^>]*>(.*?)<\/h2>/g;
      const matches = htmlString.match(regex);
      if (matches) {
        const data = matches
          .map(function (match) {
            return match.replace(/<\/?h2[^>]*>/g, "");
          })
          .map((html) => {
            return html.replace(/<[^>]+>/g, "").replace(/&[^;]+;/g, "");
          })
          .filter((item) => !item.includes("<img"));
        this.contentSecondLevelTitles[value] = data.map((content) => {
          const currentData = {
            content,
            index: this.currentSecondindex,
          };
          this.currentSecondindex++;
          return currentData;
        });
      }
    },
    handleChangeMenu(content, key) {
      this.currentBallindex = 0;
      this.currentMenu = content;
      this.jumpTo(`heading_${key}`);
    },
    jumpTo(sectionId) {
      const section = document.getElementById(sectionId);
      const container = document.getElementById("information-box-conter");
      if (section && container) {
        // 使用 scrollTo 方法来实现跳转
        console.log(section.offsetTop, container, 34344);
        container.scrollTo({
          top: section.offsetTop,
          behavior: "smooth", // 可选，使滚动平滑
        });
      }
    },
    replaceSecondLevelAnchorContent(htmlString) {
      const regex = /<h2[^>]*>(.*?)<\/h2>/g;
      let idCounter = 0;
      htmlString = htmlString.replace(regex, function (match) {
        var id = "heading_second_" + idCounter;
        idCounter++;
        return match.replace(
          "<h2",
          '<h2 class="highlight-wrapper" id="' + id + '"'
        );
      });
      return htmlString;
    },
    closeClick() {
      this.seeVisible = false;
    },
    nextClick() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.announcementIndex += 1;
      }, 350);
    },
    enclosureClick(url, name) {
      if (!url) return;
      const urlParamsAry = url.split("/");
      const fName =
        urlParamsAry && urlParamsAry.length
          ? urlParamsAry[5].split("?")[0]
          : "";
      let suffix = ".jpg";
      if (fName) {
        suffix = fName.substring(fName.indexOf("."), fName.length); // .jpg
      }
      const fileName =
        urlParamsAry && urlParamsAry.length
          ? `${urlParamsAry[3]}/${urlParamsAry[4]}/${fName}`
          : "";
      if (!fileName) {
        this.$message.error(this.$t("common_home_param_error_nont_download"));
      }
      const formData = new FormData();
      formData.append("token", this.$ls.get(ACCESS_TOKEN));
      formData.append("fileName", fileName);

      DownloadImg(formData).then((res) => {
        downloadFn(res, name + suffix);
      });
    },
  },
  mounted() {
    this._GetAnnouncementYhDetail();
  },
};
</script>
<style lang="less" scoped>
.container-wrapper {
  position: relative;
  display: flex;
}
.left-wrapper {
  position: relative;
  flex: 0 0 250px;
  padding: 20px;
  padding-top: 24px;
  width: 250px;
  padding-right: 0;
  background: #fafafc;
  height: 90vh;
}
.content-wrapper {
  position: relative;
  flex: 1;
}
.right-anchor-wrapper {
  position: absolute;
  top: 10px;
  right: 30px;
}
.menu-wrapper {
  position: relative;
  margin-top: 24px;
  width: 214px;
  background: none;
  max-height: 540px;
  overflow: auto;
  border: none;
}
.announcement-title {
  position: relative;
  width: 212px;
  font-size: 24px;
  color: #000000;
  margin-right: 18px;
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 在溢出的位置显示省略号 */
  display: -webkit-box; /* 使用 WebKit 浏览器的盒子布局 */
  -webkit-line-clamp: 2; /* 显示的行数 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
}
.pointer-container {
  position: absolute;
  top: 0;
}
.menu-title-name {
  display: inline-block;
  position: relative;
  width: 200px;
  margin-left: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.anchor-information-container {
  position: relative;
  margin-top: 40px;
  overflow: auto;
  max-height: 680px;
}
/deep/.home-ant-anchor-wrapper {
  margin-left: 0 !important;
}

.anchor-information-wrapper {
  position: relative;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.home-ant-menu:not(.home-ant-menu-horizontal) .home-ant-menu-item-selected {
  background-color: #f0f4ff;
  color: #000000;
  font-size: 14px;
  a {
    color: #1e5af9 !important;
  }
  .pointer-container::before {
    background-color: #1e5af9;
  }
}
/deep/.home-ant-menu-item {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.home-ant-menu-item > a {
  color: #4e535c !important;
}
/deep/.home-ant-anchor-link-active > .home-ant-anchor-link-title {
  color: #0b1019 !important;
}
/deep/.home-ant-anchor-link-active {
  a {
    color: #1e5af9 !important;
  }
}
/deep/.home-ant-anchor-link > .home-ant-anchor-link-title {
  color: rgba(0, 0, 0, 0.65) !important;
}
.anchor-ball {
  position: absolute;
  content: "";
  margin-top: 47px;
  left: 4px;
  height: 16px;
  width: 2px;
  background: #1e5af9;
  z-index: 9;
}
/deep/.home-ant-anchor-ink-ball {
  display: none !important;
}
/deep/.home-ant-modal-body {
  padding: 0 !important;
}
.anticon {
  margin-right: 3px;
}
.pointer-container::before {
  position: relative;
  left: -6px;
  top: -2px;
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 6px;
  height: 6px;
  background-color: grey;
}
.information-box-header {
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  font-weight: 400;
  color: #333333;
  border-bottom: 1px solid #ccc;
}
.information {
  overflow: auto;
  height: 90vh;
  margin: 0 0 0 -14px;
  padding-right: 190px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    /*滑道*/
    box-shadow: inset 0 0 6px rgba(102, 102, 102, 0);
    -webkit-box-shadow: inset 0 0 6px rgba(102, 102, 102, 0);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;

    background: rgba(102, 102, 102, 0.2);
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 102, 102, 0.3);
  }
}
.information-box-conter {
  padding: 0 14px 0 24px;
  &_title {
    padding: 24px 0 11px 0;
    line-height: 25px;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    margin: 0 15px 0 0px;
    text-indent: 10px;
    position: relative;
    &::before {
      content: "";
      display: block;
      background: #5794fd;
      width: 3px;
      height: 14px;
      position: absolute;
      top: 50%;
      margin-top: -1px;
    }
  }
  &_tips {
    font-weight: 400;
    color: #777777;
    margin: 20px 0 10px 0;
    line-height: 20px;
    display: flex;
  }
  &_loading {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
  }
}
.information-flooer {
  position: fixed;
  bottom: 0;
  width: 98%;
  height: 50px;
  line-height: 50px;
  text-align: right;
  border-top: 1px solid #ccc;
}
.detail-header-span {
  font-size: 16px;
  line-height: 20px;
  margin: 17px 0 -9px 0;
  cursor: pointer;
  color: #1890ff;
  span {
    margin-left: 11px;
  }
}
/deep/.@{ant-prefix}-modal-body {
  padding: 0 24px;
}
</style>
